import { useHttp } from "../http/useHttp";
import { useAxiosQuery } from "../http/useAxiosQuery";
import { useDefaultError } from "@synota-io/synota-shared-ui";
import { paths } from "../generated-types";

type UsersOperation = paths["/dashboard/users"]["get"];
type UseUsersResponse = UsersOperation["responses"][200]["content"]["application/json"];

export type IDashboardUser = UseUsersResponse[number];

export const useUsers = () => {
  const { client } = useHttp();
  const { status, isPending, isFetching, isLoading, data, error, refetch } =
    useAxiosQuery<UseUsersResponse>({
      queryKey: ["users"],
      queryFn: ({ signal }) => client.get("/users", { signal }),
    });

  useDefaultError(error, "Failed to get users");

  return {
    users: data ? data.data : null,
    status,
    isPending,
    isFetching,
    isLoading,
    error,
    refetch,
  };
};

export type UseUsersReturn = ReturnType<typeof useUsers>;
